export default "/catalog/_next/static/scripts/polyfill.b94bc06dd58d851bf13eaaf38c38a9ff.js";